import { Button, Dropdown } from 'antd';
import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';

const AntdDropdown = ({ menuNav, children }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleVisibleChange = (value) => {
    setIsDropdownOpen(value);
  };

  return (
    <Dropdown
      menu={menuNav}
      placement="bottomLeft"
      trigger={['click']}
      getPopupContainer={(trigger) => trigger.parentNode}
      onOpenChange={handleVisibleChange}
      open={isDropdownOpen}
    >
      <Button>
        {children}
        <DownOutlined
          className={isDropdownOpen ? 'rotate-icon' : ''}
          style={{
            transition: 'transform 0.3s',
            transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </Button>
    </Dropdown>
  );
};

export default AntdDropdown;
